import React, { useEffect, useMemo, useState } from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import { formatNumber, toNum } from "@shared/utils/CommonUtils";
import { snSysWidget001 } from "./icons";

interface Props {
  cdWidget?: string;
  nmWidget?: string;
  searchData?: any;
  refreshKey?: number;
}

const SnSysWidget001: React.FC<Props> = ({
  nmWidget,
  searchData,
  refreshKey,
}) => {
  const { userInfo } = global();
  const [dataSource, setDataSource] = useState<any>();

  const params = useMemo(
    () => ({
      cd_firm: searchData?.cd_firm || userInfo.cd_firm,
      dt: searchData?.dt,
    }),
    [searchData?.cd_firm, searchData?.dt, userInfo.cd_firm]
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const param = {
          id: "sn_sys_widget_001_01",
          params,
        };
        const data: any = await fnGetDataSet(param);
        setDataSource(data?.[0]?.[0] || {});
      } catch (error) {}
    };

    fetchData();
  }, [params, refreshKey]);

  const amount = toNum(dataSource?.am_k);
  const rate = toNum(dataSource?.rt_diff);
  const isIncrease = rate >= 0;

  return (
    <div className="flex h-full min-h-[126px] w-full flex-col justify-between rounded-lg border border-gray-100 bg-white px-4 py-3 shadow-sm">
      <div className="flex items-center gap-4">
        <div className="h-20 aspect-square shrink-0">
          <img
            src={snSysWidget001}
            alt=""
            className="h-full w-full object-contain"
          />
        </div>

        <div className="min-w-0 flex-1">
          <div className="truncate mb-2 text-xl font-bold text-slate-900">
            {nmWidget}
          </div>
          <div className="flex items-baseline gap-2 whitespace-nowrap">
            <span className="text-3xl font-semibold tracking-normal text-slate-900">
              {formatNumber(amount, { fractionDigits: 0 })}
            </span>
            <span className="text-lg font-semibold text-slate-800">만원</span>
          </div>
        </div>
      </div>

      <div className="mt-3 border-t border-gray-100 pt-3">
        <div className="flex items-center justify-between text-base font-semibold">
          <span className="text-slate-800">전년대비</span>
          <span
            className={`flex items-center gap-1 ${
              isIncrease ? "text-green-600" : "text-red-500"
            }`}
          >
            <span>{isIncrease ? "▲" : "▼"}</span>
            <span>{formatNumber(rate, { fractionDigits: 1, abs: true })}%</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default SnSysWidget001;
